module.exports = __webpack_public_path__ + "img/happy_product_item.747572fe.png";